const Render = (props) => {
  return props.render();
};

export default Render;
